/**
*  Copyright (c) 2022 Micro Focus Software Inc.  All Rights Reserved.
*
* THIS WORK IS AN UNPUBLISHED WORK AND CONTAINS CONFIDENTIAL PROPRIETARY
* AND TRADE SECRET INFORMATION OF MICRO FOCUS SOFTWARE INC. ACCESS  TO  THIS
* WORK IS RESTRICTED TO (I) MICRO FOCUS SOFTWARE INC. EMPLOYEES WHO HAVE A NEED
* TO  KNOW HOW TO  PERFORM  TASKS WITHIN  THE SCOPE  OF  THEIR   ASSIGNMENTS
* AND (II) ENTITIES OTHER  THAN  MICRO FOCUS SOFTWARE INC.  WHO  HAVE ENTERED
* INTO APPROPRIATE LICENSE   AGREEMENTS.  NO  PART  OF  THIS WORK MAY BE USED,
* PRACTICED, PERFORMED COPIED, DISTRIBUTED, REVISED, MODIFIED, TRANSLATED, ABRIDGED,
* CONDENSED, EXPANDED, COLLECTED, COMPILED, LINKED,  RECAST, TRANSFORMED
* OR ADAPTED  WITHOUT THE PRIOR WRITTEN CONSENT OF MICRO FOCUS SOFTWARE INC.
* ANY USE OR EXPLOITATION  OF  THIS WORK WITHOUT AUTHORIZATION COULD SUBJECT
* THE PERPETRATOR  TO CRIMINAL AND CIVIL LIABILITY.
*/

import { Component, OnInit } from '@angular/core';
import { QuickCallBasicInfo, QuickCallResponse } from '../../feature/newrequest/quickcall/model/quickcallresponse';
import { QuickCallService } from '../../feature/newrequest/quickcall/service/quickcalllist.service';
import { Router, NavigationExtras } from '@angular/router';
import { ZSDTranslateService } from '../../../common/zsd-translate.service';
import { HttpClient, HttpParams } from '@angular/common/http';
import { SpinnerService } from '../../../shared/spinner/spinner.service';
import { RequestslistService } from '../../feature/requests/services/requestslist.service';
import { RequestsListResponse, RequestBasicInfoResultEntity } from '../../feature/requests/model/requestslistresponse';
import { PlannedOutagesResponse } from '../../feature/outages/model/plannedoutagesresponse';
import { OutagesService } from '../../feature/outages/services/outages.service';
import { OutagesFilterInfo } from '../../feature/outages/model/outagesfilterinfo';
import { KbaResponse, KbaBasicInfo } from '../../feature/selfhelp/model/kbaresponse';
import { KbaService } from '../../feature/selfhelp/services/kba.service';
import { KnowledgeBaseFilterInfo } from '../../feature/selfhelp/model/knowledgebasefilterinfo';
import { CommonConstants } from '../../../common/constants/common-constants';
import { UIMessagesResponse } from '../../feature/shared/model/uimessagesresponse';
import { CustomerPreferenceService } from '../../preference/customerpreference.service';
import { CustomerPreferenceUtil } from '../../preference/customerpreferenceutil';
import { UIMessageService } from '../../feature/shared/services/uimessages.service';
import { DomSanitizer } from '@angular/platform-browser';
import { CustomerPreferenceResponse } from '../../preference/customerpreference.model';
import { AlertResponse } from '../../../shared/alert/alertmessage';
import { BannerComponent } from '../banner/banner.component';
import { SurveyResponse } from './../../../shared/alert/alertmessage';
import { PlannedOutagesBasicInfo } from './../../feature/outages/model/plannedoutagesresponse';
import { AlertService } from '../../../shared/alert/alert.service';
import { LoginService } from '../../../login/login.service';
import { CustomizationEnabledResponse } from '../../../login/model/customizationenabledresponse';
import { UserProfileService } from '../userprofile/userprofile.service';
import { ToastrService } from 'ngx-toastr';

declare var $: any;

@Component({
    selector: 'zsd-home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.scss'
    ]
})

export class HomeComponent implements OnInit {
    showStoreMenu = false;
    showRequestMenu: boolean;
    showItemMenu = false;
    showServiceMenu = false;
    canCusotmerViewPlannedOutages: boolean;
    showOutageMenu = false;
    showCreateNewRequest;
    canViewIncidents = false;
    canEditIncidents = false;
    canViewServiceRequests = false;
    canEditServiceRequests = false;
    canViewChangeRequests = false;
    canEditChangeRequests = false;
    canCreateIncidents = false;
    canCreateServiceRequests = false;
    canCreateChangeRequests = false;
    canCustomerViewOutages = false;
    showQuickCall: boolean;
    searchPage: string;
    searchTerm: string;
    searchPageName: string;
    enabledTab: string;
    uiMessageListResults: Array<UIMessagesResponse> = [];
    storeLegend = '';
    createRequestLegend = '';
    outagesLegend = '';
    selfHelpLegend = '';
    searchPageUrl: string;
    showRequestCard = false;
    showKbaCard: boolean;
    showOutagesCard = false;
    imagePath;
    customizationEnabled: boolean;
    imageLoaded = false;
    customizedImage = false;
    timeInterval: string;
    stopInterval = 'marquee 0s linear 1s infinite';
    isAlertDetailVisible: boolean;
    alertDetails: AlertResponse;


    // Parameters declaration to fetch the results
    requestSortBy = 'lastActionDate';
    plannedOutagesSortBy = 'startDate';
    openRequest = 'openRequest';
    sortOrder = 'DESC';
    requestPerPage = 5;
    plannedOutagesPerPage = 5;
    page = 0;

    isLoading = false;
    isRequestLoading = false;
    isRequestApprovalLoading = false;
    isQuickCallLoading = false;
    isKbaLoading = false;
    isOutagesLoading = false;
    isSurveyLoading = false;
    requestSpinnerStart = true;
    requestApprovalSpinnerStart = true;
    quickCallSpinnerStart = true;
    kbaSpinnerStart = true;
    outagesSpinnerStart = true;
    surveySpinnerStart = true;
    isSortedAsc = false;
    maxNoOfRequests: number;
    maxNoOfAwaitingRequests: number;
    maxNoOfPlannedOutages: number;
    isPlannedOutageslist: boolean;
    scrollEndReached = false;
    isDesc = true;

    kbaResponse: KbaBasicInfo[] = [];
    isKbalist: boolean;
    maxNoOfItems: number;
    kbaResultsCount = 0;
    kbaPerPage = 5;
    kbaArticleCount = 0;
    kbaFaqCount = 0;
    kbaSolutionCount = 0;
    readonly KBA_TYPE_ARTICLE = 1000;
    readonly KBA_TYPE_FAQ = 2000;
    readonly KBA_TYPE_SOLUTION = 4000;
    knowledgebasefilterinfo: KnowledgeBaseFilterInfo = new KnowledgeBaseFilterInfo();
    kbaBasicInfoResponse = new Array<KbaBasicInfo>();
    showElement = true;

    requestListBasicInfoResponse = new Array<RequestBasicInfoResultEntity>();
    awaitingRequestLisInfoResponse = new Array<RequestBasicInfoResultEntity>();

    requestListResponse: RequestsListResponse = new RequestsListResponse();
    outagesFilterInfo = new OutagesFilterInfo();
    spinnerStart = true; // adding for showing spinner while loading instead of No request message
    quickCallBasicInfoResponse = new Array<QuickCallBasicInfo>();
    plannedOutagesBasicInfoResponse = new Array<PlannedOutagesBasicInfo>();
    alertInfoResponse = new Array<AlertResponse>();
    information = 'Information';
    urgent = 'Urgent';
    warning = 'Warning';
    surveyResponse = new Array<SurveyResponse>();
    quickCallId: number;
    quickCallType: string;
    quickCallName: string;
    quickCallTypeKey: string;
    showAlerts = true;
    topMargin: string;
    allKba = 'all';
    article = 'article';
    faqs = 'faqs';
    solution = 'solution';
    alertLink = '';
    sortedIds = ['request', 'awaitingrequest', 'quickcall', 'kba', 'outage', 'survey'];
    changeInOrder = false;
    indexofrequest: number;
    indexofawaitingrequest: number;
    indexofquickcall: number;
    indexofkba: number;
    indexofoutage: number;
    indexofsurvey: number;

    constructor(public requestListsService: RequestslistService, public quickCallService: QuickCallService,
        public outagesService: OutagesService,
        public zsdTranslate: ZSDTranslateService, public http: HttpClient,
        public spinnerService: SpinnerService, public kbaService: KbaService,
        private customerPreferenceService: CustomerPreferenceService,
        private router: Router,
        public loginService: LoginService,
        private customerPreference: CustomerPreferenceUtil,
        private uiMessageService: UIMessageService, private alertService: AlertService,
        public _DomSanitizer: DomSanitizer,
        public userprofileservice: UserProfileService,
        public toastrservice: ToastrService) {
    }


    ngOnInit() {
        this.getDashletOrder();
        /* To refresh Global search dropdown */
        BannerComponent.refreshGlobalSearchDropdown.next(false);
        this.getCustomerPreferenceAndcustomizableStrings();

        this.loginService.isCustomizeEnabled().subscribe(
            (response: CustomizationEnabledResponse) => {
                this.customizationEnabled = response.customizeEnabled;
                if (this.customizationEnabled) {
                    this.customizedImage = true;  // Making Flag customizedImage true if Use Custom is enabled
                    this.imagePath = 'url("../LiveTime/images/banners/custom/custom_eupClientBanner.png")';
                } else {
                    this.imagePath = 'url("img/mainbanner.jpg")';
                }
                this.imageLoaded = true;
            },
            err => {
                console.error('Error occurred while fetching use customization enabled or not value');
                console.error(err.error);
            }
        );
    }

    getHomePageData() {
        if (this.showRequestMenu) {
            this.getRequestsList();
            this.getAwaitingRequestsList();
        }
        if (this.showQuickCall) {
            this.getQuickCallList();
        }
        if (this.canCusotmerViewPlannedOutages) {
            this.getPlannedOutagesList();
        }
        this.getKbasList(this.knowledgebasefilterinfo);
        this.getAlerts();
        this.getSurveys();
    }

    getCustomerPreferenceAndcustomizableStrings() {
        this.customerPreferenceService
            .getPreferenceList()
            .subscribe((preference: CustomerPreferenceResponse) => {
                // privilege check to show store dropdown Menu
                this.showStoreMenu = preference.appStoreCustomerEnable;
                if (this.showStoreMenu) {
                    this.showStoreMenu = true;
                }

                // privilege check to show   dropdown request Menu
                this.showQuickCall = preference.showQuickCall;
                this.canViewIncidents = preference.canViewIncidents;
                this.canEditIncidents = preference.canEditIncidents;
                this.canViewServiceRequests = preference.canViewServiceRequests;
                this.canEditServiceRequests = preference.canEditServiceRequests;
                this.canViewChangeRequests = preference.canViewChangeRequests;
                this.canEditChangeRequests = preference.canEditChangeRequests;
                this.canCustomerViewOutages = preference.canCustomerViewOutages;
                this.canCusotmerViewPlannedOutages = preference.canCusotmerViewPlannedOutages;

                if (this.canViewIncidents || this.canEditIncidents || this.canViewServiceRequests ||
                    this.canEditServiceRequests || this.canViewChangeRequests || this.canEditChangeRequests) {
                    this.showRequestMenu = true;
                }

                // privilege check to show dropdown service Menu
                this.showServiceMenu = preference.showService;
                // privilege check to show item Menu
                this.showItemMenu = preference.canViewItems;

                // privilege check to show dropdown outages Menu
                this.showOutageMenu = preference.canCustomerViewOutages;
                this.canCusotmerViewPlannedOutages = preference.canCusotmerViewPlannedOutages;

                // privilege check to show create new request card
                this.canCreateIncidents = preference.canCreateIncidents;
                this.canCreateServiceRequests = preference.canCreateServiceRequests;
                this.canCreateChangeRequests = preference.canCreateChangeRequests;
                if (this.canCreateIncidents || this.canCreateServiceRequests || this.canCreateChangeRequests) {
                    this.showCreateNewRequest = true;
                }
                this.setDefaultDropdown();
                this.getHomePageData();
            });
        this.customerPreference.setPrivilgesBasedPreferences().then(() => {
            let privilegeEnabledTab: Array<string> = JSON.parse(localStorage.getItem('cusPref'));
            this.enabledTab = privilegeEnabledTab[0];
            this.chooseSearchPage(this.enabledTab.substring(1));
        });

        /* getting the customizable strings from admin portal and setting to the card */
        this.uiMessageService.getUIMessagesList().subscribe(
            (uimessages: UIMessagesResponse[]) => {
                this.uiMessageListResults = uimessages;
                for (let i = 0; i < this.uiMessageListResults.length; i++) {
                    if (this.uiMessageListResults[i].name === 'HomePageStoreLegend') {
                        this.storeLegend = this.uiMessageListResults[i].content;
                    }
                    if (this.uiMessageListResults[i].name === 'HomePageCreateRequestLegend') {
                        this.createRequestLegend = this.uiMessageListResults[i].content;
                    }
                    if (this.uiMessageListResults[i].name === 'HomePageOutagesLegend') {
                        this.outagesLegend = this.uiMessageListResults[i].content;
                    }
                    if (this.uiMessageListResults[i].name === 'HomePageSelfHelpLegend') {
                        this.selfHelpLegend = this.uiMessageListResults[i].content;
                    }
                }
            },
            err => console.log(err)
        );
    }
    chooseSearchPage(page) {
        this.searchPage = page;
        if (this.searchPage === 'store') {
            this.searchPageName = 'Home.store';
        } else if (this.searchPage === 'requests') {
            this.searchPageName = 'Home.request';
        } else if (this.searchPage === 'services') {
            this.searchPageName = 'Home.service';
        } else if (this.searchPage === 'items') {
            this.searchPageName = 'Home.item';
        } else if (this.searchPage === 'selfhelp') {
            this.searchPageName = 'Home.selfHelp';
        } else if (this.searchPage === 'currentoutages') {
            this.searchPageName = 'Home.outages';
        } else if (this.searchPage === 'plannedoutages') {
            this.searchPageName = 'Home.plannedOutages';
        }
    }

    hideDropDown() {
        $('div.dropdown-menu').removeClass('show');
    }
    setDefaultDropdown() {
        if (this.showStoreMenu) {
            this.searchPage = 'store';
        } else if (this.showRequestMenu) {
            this.searchPage = 'requests';
        } else if (this.showServiceMenu) {
            this.searchPage = 'services';
        } else if (this.showItemMenu) {
            this.searchPage = 'items';
        } else if (this.showOutageMenu) {
            this.searchPage = 'currentoutages';
        } else if (this.canCusotmerViewPlannedOutages) {
            this.searchPage = 'plannedoutages';
        }
        this.chooseSearchPage(this.searchPage);
        this.setsearchPageUrl(this.searchPage);
    }
    setsearchPageUrl(searchPage) {
        if (searchPage === 'store') {
            this.searchPageUrl = CommonConstants.STORE_COMPONENT;
        } else if (searchPage === 'services') {
            this.searchPageUrl = CommonConstants.SERVICES_COMPONENT;
        } else if (searchPage === 'requests') {
            this.searchPageUrl = CommonConstants.REQUEST_COMPONENT;
        } else if (searchPage === 'selfhelp') {
            this.searchPageUrl = CommonConstants.SELFHELP_COMPONENT;
        } else if (searchPage === 'items') {
            this.searchPageUrl = CommonConstants.ITEMS_COMPONENT;
        } else if (searchPage === 'currentoutages') {
            this.searchPageUrl = CommonConstants.OUTAGES_COMPONENT + CommonConstants.CURRENT_OUTAGES_COMPONENT;
        } else if (searchPage === 'plannedoutages') {
            this.searchPageUrl = CommonConstants.OUTAGES_COMPONENT + CommonConstants.PLANNED_OUTAGES_COMPONENT;
        }
    }

    clickSearch() {
        if (this.searchTerm === '') {
            this.searchTerm = null;
        }
        if (this.searchTerm !== null) {
            this.searchTerm = JSON.stringify(this.searchTerm);
        }
        let navigationExtras: NavigationExtras = {
            queryParams: {
                'searchTerm': this.searchTerm
            },
            queryParamsHandling: 'merge'
        };
        this.setsearchPageUrl(this.searchPage);
        this.router.navigateByUrl('/my-profile', { skipLocationChange: true }).then(() =>
            this.router.navigate([this.searchPageUrl], navigationExtras));
    }

    loadPageOnCardClick(id: string) {
        let searchPageUrl: string;
        if (id === 'store') {
            searchPageUrl = CommonConstants.STORE_COMPONENT;
        }
        if (id === 'selfhelp') {
            searchPageUrl = CommonConstants.SELFHELP_COMPONENT;
        }
        if (id === 'outages') {
            searchPageUrl = CommonConstants.OUTAGES_COMPONENT;
        }
        if (id === 'newrequest') {
            searchPageUrl = CommonConstants.NEWREQUEST_COMPONENT;
        }
        this.router.navigate([searchPageUrl]);
    }

    getRequestsList() {
        let params = new HttpParams()
            .set('offset', this.page.toString())
            .set('limit', this.requestPerPage.toString())
            .set('sortBy', this.openRequest)
            .set('sortOrder', 'ASC');

        if (this.requestListBasicInfoResponse.length > 0) {
            this.isRequestLoading = false;
            this.requestSpinnerStart = false;
            return this.requestListBasicInfoResponse;
        }
        if (!this.isRequestLoading) {
            this.isRequestLoading = true;
            this.spinnerService.show();
            this.requestListsService.getRequestsList(params)
                .subscribe(
                    (requestListResponse: RequestsListResponse) => {
                        this.isRequestLoading = false;
                        this.requestSpinnerStart = false;
                        this.maxNoOfRequests = requestListResponse.resultCount;
                        this.requestListBasicInfoResponse = requestListResponse.results;
                    },
                    err => {
                        console.log(err.error);
                    }
                );
        }
    }

    getAwaitingRequestsList() {
        let params = new HttpParams()
            .set('offset', this.page.toString())
            .set('limit', this.requestPerPage.toString())
            .set('sortBy', this.requestSortBy)
            .set('sortOrder', this.sortOrder);

        params = params.append('awaitingMyApproval', 'true');
        params = params.append('needMyInput', 'true');

        if (this.awaitingRequestLisInfoResponse.length > 0) {
            this.isRequestApprovalLoading = false;
            this.requestApprovalSpinnerStart = false;
            return this.awaitingRequestLisInfoResponse;
        }
        if (!this.isRequestApprovalLoading) {
            this.isRequestApprovalLoading = true;
            this.spinnerService.show();
            this.requestListsService.getRequestsList(params)
                .subscribe(
                    (requestListResponse: RequestsListResponse) => {
                        this.isRequestApprovalLoading = false;
                        this.requestApprovalSpinnerStart = false;
                        this.maxNoOfAwaitingRequests = requestListResponse.resultCount;
                        this.awaitingRequestLisInfoResponse = requestListResponse.results;
                    },
                    err => {
                        console.log(err.error);
                    }
                );
        }
    }

    getQuickCallList() {
        if (this.quickCallBasicInfoResponse.length > 0) {
            this.isQuickCallLoading = false;
            this.quickCallSpinnerStart = false;
            return this.quickCallBasicInfoResponse;
        }
        if (!this.isQuickCallLoading) {
            this.isQuickCallLoading = true;
            this.spinnerService.show();
            this.quickCallService.getQuickCallList()
                .subscribe(
                    (quickCallResponse: QuickCallResponse) => {
                        this.isQuickCallLoading = false;
                        this.quickCallSpinnerStart = false;
                        if (quickCallResponse.resultCount > 0) {
                            this.quickCallBasicInfoResponse = quickCallResponse.results;
                        }
                    },
                    err => {
                        console.log(err.error);
                    }
                );
        }
    }

    getPlannedOutagesList() {
        let params = new HttpParams()
            .set('offset', this.page.toString())
            .set('limit', this.plannedOutagesPerPage.toString())
            .set('sortBy', this.plannedOutagesSortBy)
            .set('sortOrder', this.sortOrder);
        if (!this.isOutagesLoading) {
            this.isOutagesLoading = true;
            this.spinnerService.show();
            this.outagesService.getPlannedOutagesList(params, this.outagesFilterInfo).subscribe(
                (plannedOutagesResponse: PlannedOutagesResponse) => {
                    this.isOutagesLoading = false;
                    this.outagesSpinnerStart = false;
                    this.maxNoOfPlannedOutages = plannedOutagesResponse.resultCount;
                    if (this.maxNoOfPlannedOutages > 0) {
                        this.isPlannedOutageslist = true;
                        this.scrollEndReached = false;
                    }
                    this.plannedOutagesBasicInfoResponse = plannedOutagesResponse.results;
                    this.showOutagesCard = true;
                },
                err => {
                    console.log(err.error);
                    this.showOutagesCard = false;
                    this.isPlannedOutageslist = false;
                }
            );
        }
    }
    getKbasList(knowledgebasefilterinfo: KnowledgeBaseFilterInfo) {
        let params = new HttpParams()
            .set('offset', this.page.toString())
            .set('limit', this.kbaPerPage.toString());
        if (!this.isKbaLoading) {
            this.isKbaLoading = true;
            this.spinnerService.show();
            this.http
                .post<KbaResponse>(
                    CommonConstants.SERVICE_VERSION_PATH_V1 + '/customer/kbas',
                    knowledgebasefilterinfo, { params }
                ).subscribe(resp => {
                    this.isKbaLoading = false;
                    this.kbaSpinnerStart = false;
                    this.maxNoOfItems = resp.resultCount;
                    this.kbaArticleCount = resp.articleCount;
                    this.kbaFaqCount = resp.faqCount;
                    this.kbaSolutionCount = resp.solutionCount;
                    this.kbaResultsCount = this.kbaArticleCount + this.kbaFaqCount + this.kbaSolutionCount;
                    if (this.maxNoOfItems > 0) {
                        this.isKbalist = true;
                        this.scrollEndReached = false;
                    }
                    this.kbaBasicInfoResponse = this.kbaBasicInfoResponse.concat(
                        resp.results
                    );
                    for (let i = 0; i < this.kbaBasicInfoResponse.length; i++) {
                        $(function () {
                            $('#rateYo' + i).rateYo({
                                starWidth: '16px',
                                rating: resp.results[i].averageRating,
                                ratedFill: '#15DB66',
                                normalFill: '#D4D6DA',
                                readOnly: true
                            });
                        });
                    }
                    this.showKbaCard = true;
                },
                    err => {
                        this.showKbaCard = false;
                        console.log(err);
                    }
                );
        }
    }
    onChangeKbaType(option: string) {
        this.isKbaLoading = false;
        this.kbaSpinnerStart = true;
        this.page = 0;
        this.kbaBasicInfoResponse = [];
        if (option === 'all') {
            this.knowledgebasefilterinfo.kbaType = null;
        }
        if (option === 'article') {
            this.knowledgebasefilterinfo.kbaType = this.KBA_TYPE_ARTICLE;
        }

        if (option === 'faqs') {
            this.knowledgebasefilterinfo.kbaType = this.KBA_TYPE_FAQ;
        }

        if (option === 'solution') {
            this.knowledgebasefilterinfo.kbaType = this.KBA_TYPE_SOLUTION;
        }
        this.getKbasList(this.knowledgebasefilterinfo);
    }

    scrollCur() {
    }

    loadSelfHelpPage() {
        if (this.knowledgebasefilterinfo.kbaType === null) {
            this.knowledgebasefilterinfo.kbaTabType = this.allKba;
        }
        if (this.knowledgebasefilterinfo.kbaType === this.KBA_TYPE_ARTICLE) {
            this.knowledgebasefilterinfo.kbaTabType = this.article;
        }
        if (this.knowledgebasefilterinfo.kbaType === this.KBA_TYPE_FAQ) {
            this.knowledgebasefilterinfo.kbaTabType = this.faqs;
        }
        if (this.knowledgebasefilterinfo.kbaType === this.KBA_TYPE_SOLUTION) {
            this.knowledgebasefilterinfo.kbaTabType = this.solution;
        }
        this.knowledgebasefilterinfo.kbaTabType = JSON.stringify(this.knowledgebasefilterinfo.kbaTabType);

        let navigationExtras: NavigationExtras = {
            queryParams: {
                'kbaType': this.knowledgebasefilterinfo.kbaTabType
            },
            queryParamsHandling: 'merge'
        };
        this.router.navigateByUrl('/my-profile', { skipLocationChange: true }).then(() =>
            this.router.navigate([CommonConstants.SELFHELP_COMPONENT], navigationExtras));
    }

    showIndividualRequestPage(requestNumber: number) {
        let search = 'id:' + requestNumber;
        let searchTerm = JSON.stringify(search);
       return searchTerm;
    }

    showRequestPage(requestNumber: number) {
        let search = 'id:' + requestNumber;
        let searchTerm = JSON.stringify(search);
        let navigationExtras: NavigationExtras = {
            queryParams: {
                'searchTerm': searchTerm
            },
            queryParamsHandling: 'merge'
        };
        this.router.navigateByUrl('/my-profile', { skipLocationChange: true }).then(() =>
            this.router.navigate([CommonConstants.REQUEST_COMPONENT], navigationExtras));
    }
    getAlerts() {
        if (!this.isLoading) {
            this.isLoading = true;
            this.spinnerService.show();
            this.outagesService.getAlertList()
                .subscribe(
                    (alertResponse: AlertResponse[]) => {
                        this.alertInfoResponse = alertResponse;
                        this.timeInterval = this.getScrollingSpeed(this.alertInfoResponse.length);
                    },
                    err => {
                        console.log(err);
                    }
                );
        }
        this.isLoading = false;
        this.spinnerStart = false;
    }
    getScrollingSpeed(size: number) {
        let time: number;
        if (size <= 5) {
            time = 30;
        } else {
            time = size * 6;
        }
        let speed = `marquee ${time}s linear 1s infinite`;
        return speed;
    }
    getSurveys() {
        if (!this.isSurveyLoading) {
            this.isSurveyLoading = true;
            this.spinnerService.show();
            this.outagesService.getSurveyList()
                .subscribe(
                    (surveyResponse: SurveyResponse[]) => {
                        this.isSurveyLoading = false;
                        this.surveySpinnerStart = false;
                        this.surveyResponse = surveyResponse;
                    },
                    err => {
                        console.log(err);
                    }
                );
        }
    }
    getQuickCallinfo(quickCall: QuickCallBasicInfo) {
        this.quickCallId = quickCall.quickCallId;
        this.quickCallType = quickCall.quickCallType;
        this.quickCallName = quickCall.name;
        this.quickCallTypeKey = quickCall.typeKey;
    }
    resetQuickCall() {
        this.quickCallId = null;
        this.quickCallType = null;
        this.quickCallName = null;
        this.quickCallTypeKey = null;
        if (this.router.url.includes('/home')) {
            this.alertService.delAlert();
        }
    }
    hideAlerts() {
        this.showAlerts = false;
        this.topMargin = '3.5rem';
    }
    alertDiscription(alert: AlertResponse) {
        this.isAlertDetailVisible = true;
        if (!this.isLoading) {
            this.isLoading = true;
            this.spinnerService.show();
            try {
                this.outagesService.getAlertDetails(alert.alertId).subscribe(
                    (_alertResponse: AlertResponse) => {
                        this.alertDetails = _alertResponse;
                       // this.createAlertLink();
                        this.isLoading = false;
                        this.spinnerStart = false;
                    },
                    err => {
                        console.log(err);
                        this.isLoading = false;
                        this.spinnerStart = false;
                    }
                );
            } catch (error) {
                console.log(error);
                console.log(this.alertDetails);
            }
        }
    }
    resetAlert() {
        this.isAlertDetailVisible = false;
        this.alertDetails = null;
    }


    getDashletOrder(){
        this.userprofileservice.getUserDashletOrder().subscribe((listofSortedIds: string[]) => {
            if (listofSortedIds) {
            this.sortedIds = listofSortedIds;
            $('#savedashlets').css('display', 'none');
            this.indexofrequest = this.sortedIds.indexOf('request');
            this.indexofawaitingrequest = this.sortedIds.indexOf('awaitingrequest');
            this.indexofquickcall = this.sortedIds.indexOf('quickcall');
            this.indexofkba = this.sortedIds.indexOf('kba');
            this.indexofoutage = this.sortedIds.indexOf('outage');
            this.indexofsurvey = this.sortedIds.indexOf('survey');
            $('#request').css('order', this.indexofrequest);
            $('#awaitingrequest').css('order', this.indexofawaitingrequest);
            $('#quickcall').css('order', this.indexofquickcall);
            $('#kba').css('order', this.indexofkba);
            $('#outage').css('order', this.indexofoutage);
            $('#survey').css('order', this.indexofsurvey);
            }
            this.updateDashletOrder();
        })
    }

    updateDashletOrder(){
        $( document ).ready(function() {
            $("#sortable").sortable({
                stop: function(){
                    $('#request').attr('style', '');
                    $('#awaitingrequest').attr('style', '');
                    $('#quickcall').attr('style', '');
                    $('#kba').attr('style', '');
                    $('#outage').attr('style', '');
                    $('#survey').attr('style', '');
                    $('#savedashlets').css('display', 'inline-block');
                   // this.sortedIds = $("#sortable").sortable("toArray");
                }
            });
        });
    }


    updateUserDashlets(){
        this.sortedIds = $("#sortable").sortable("toArray");
        let params = new HttpParams();
        for (let i=0; i < this.sortedIds.length; i++) {
          params = params.append('dashletOrder', this.sortedIds[i].toString());
        }

        this.userprofileservice.updateUserDashletOrder(params).subscribe(
            (response) => {
                console.log(response);
                $('#savedashlets').css('display', 'none');
                this.toastrservice.success('Changes are saved successfully.');
            }, err => {
              if (err) {
                this.toastrservice.error('Failed to save the changes.');
              }
            }
        );
    }


    resetToDefaultOrder(){
        this.sortedIds = ['request', 'awaitingrequest', 'quickcall', 'kba', 'outage', 'survey'];
        let params = new HttpParams();
        for (let i=0; i < this.sortedIds.length; i++) {
          params = params.append('dashletOrder', this.sortedIds[i].toString());
        }

        this.userprofileservice.updateUserDashletOrder(params).subscribe(
            (response) => {
                console.log(response);
                $('#savedashlets').css('display', 'none');
                this.getDashletOrder(); 
            }
        );
        // window.location.reload();
        // This need to change
    }
}
